import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  GiftVoucherInitModel,
  GiftVoucherInitVariables,
  GiftVoucherModel,
  GiftVoucherVariables,
} from '../../../../../models/email-template/gift-voucher.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-giftvoucher',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './gift-voucher.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gift-voucher.component.scss'
})
export class GiftVoucherComponent extends BaseComponent implements OnInit {
  @Input() block: GiftVoucherModel = new GiftVoucherInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new GiftVoucherInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Heading Text';
  textPlaceholder: string = 'Enter Text';
  imagePlaceholder: string = 'Image';
  hrefPlaceholder: string = 'Enter Image Redirect Link';
  altPlaceholder: string = 'Enter Image Alt';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof GiftVoucherVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block); // Emit the updated block data to the parent
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof GiftVoucherVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
